var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunShine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "sun-shine_svg__a",
    width: "171.4%",
    height: "171.4%",
    x: "-35.7%",
    y: "-21.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "sun-shine_svg__b",
    cx: 21,
    cy: 21,
    r: 21
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#sun-shine_svg__a)",
    xlinkHref: "#sun-shine_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#39C258",
    xlinkHref: "#sun-shine_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.233 17.229a1.035 1.035 0 010-1.444l2.12-2.167a.989.989 0 011.416 0c.39.4.39 1.046 0 1.445l-2.122 2.166a.985.985 0 01-1.414 0zM20 14.084v-3.063A1.01 1.01 0 0121 10c.552 0 1 .456 1 1.021v3.063a1.01 1.01 0 01-1 1.021c-.553 0-1-.457-1-1.021zm-6.768.98a1.038 1.038 0 010-1.446.987.987 0 011.414 0l2.122 2.167c.39.398.39 1.045 0 1.444a.986.986 0 01-1.415 0l-2.121-2.166zm12.754 11.408a20.236 20.236 0 00-9.973 0c-.003-.046-.013-.09-.013-.136 0-2.815 2.243-5.105 5-5.105s5 2.29 5 5.105c0 .046-.011.09-.014.136zm4.444 1.587a25.818 25.818 0 00-2.482-1.006c.453-4.23-2.837-7.864-6.948-7.864-4.118 0-7.401 3.641-6.948 7.864-.825.285-1.652.619-2.482 1.006-.513.239-.716.88-.46 1.392a.993.993 0 001.318.453c5.795-2.694 11.349-2.694 17.144 0a.991.991 0 001.317-.453c.256-.512.053-1.153-.46-1.392z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunShine);
export default __webpack_public_path__ + "static/media/sun-shine.c7f9d39e.svg";
export { ForwardRef as ReactComponent };